import { type FormEvent } from 'react';

export default function ContactSection() {
  const formId = 'd9mqjum8mbnljin59qrg';
  const submitAddr = 'https://readdy.ai/api/form/d9mqjum8mbnljin59qrg';

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      const msgEl = form.querySelector('.form-status');
      if (msgEl) msgEl.textContent = '提交成功，我们会尽快回复！';
      form.reset();
      return;
    }
    try {
      const formData = new FormData(form);
      const res = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let serverMsg = '';
      try { const p = JSON.parse(text); serverMsg = p?.meta?.message || p?.message || ''; } catch { serverMsg = text; }
      const msgEl = form.querySelector('.form-status');
      if (res.ok && (!serverMsg || (!serverMsg.includes('spam') && !serverMsg.includes('form data is spam')))) {
        if (msgEl) { msgEl.textContent = '提交成功！我们会尽快回复您。'; msgEl.className = 'form-status text-sm text-primary-600 mt-3 text-center'; }
        form.reset();
      } else {
        if (msgEl) { msgEl.textContent = serverMsg || '提交失败，请稍后重试'; msgEl.className = 'form-status text-sm text-red-500 mt-3 text-center'; }
      }
    } catch {
      const msgEl = form.querySelector('.form-status');
      if (msgEl) { msgEl.textContent = '网络错误，请检查连接后重试'; msgEl.className = 'form-status text-sm text-red-500 mt-3 text-center'; }
    }
  };

  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">联系我们</span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">联系咨询 · 内容投稿</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">有任何问题或建议？欢迎随时与我们取得联系，我们会在24小时内回复</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 max-w-5xl mx-auto">
          <div className="flex-1 space-y-5">
            <div className="flex items-start gap-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 flex-shrink-0"><i className="ri-mail-line text-lg"></i></span>
              <div>
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base">电子邮箱</h3>
                <p className="text-sm text-foreground-600">contact@91movie.com</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 flex-shrink-0"><i className="ri-wechat-line text-lg"></i></span>
              <div>
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base">微信公众号</h3>
                <p className="text-sm text-foreground-600">91电影视频</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 flex-shrink-0"><i className="ri-question-answer-line text-lg"></i></span>
              <div>
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base">内容投稿</h3>
                <p className="text-sm text-foreground-600">欢迎优质影视内容创作者合作</p>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <form data-readdy-form onSubmit={handleSubmit} className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                  <input type="text" name="name" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="请输入您的姓名" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                  <input type="email" name="email" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors" placeholder="请输入您的邮箱" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                  <textarea name="message" required maxLength={500} rows={4} className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none" placeholder="请描述您的问题或建议（最多500字）"></textarea>
                </div>
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden readOnly className="honeypot-field" />
                <button type="submit" className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-semibold text-sm transition-colors whitespace-nowrap cursor-pointer">发送留言</button>
              </div>
              <div className="form-status text-sm text-primary-600 mt-3 text-center"></div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}